module.exports = __webpack_public_path__ + "img/orcid.da7e4a04.png";